import FeatureText from "./feature-text";

export default FeatureText;
